import BlockFullImage1Col from 'src/components/Common/BlockFullImage1Col'

export default function Christmas() {
  return (
    <BlockFullImage1Col
      title={['christmas.happyHolidays']}
      subtitle={['christmas.happyHolidays.description']}
      bgColor='#cdd5df'
      titleColor='#222'
      video='https://gemvision.com/Images/Christmas_Video_Banner_2.mp4'
    />
  )
}
